import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { accountVehicleGroupsSchema } from '../schemas/account-vehicle-group.schema';

/**
 * Returns all of the Vehicle Groups for an Account
 * @param accountAlias The alias of the account to get the Vehicle Groups for
 * @returns An array of Account Vehicle Groups
 */
export function getVehicleGroupsAccount(this: unknown, accountAlias: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).vehicleGroupsAccountUrl(accountAlias),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(accountVehicleGroupsSchema));
}
